import React, { useEffect, useMemo } from "react";
import { useElapsedTime } from "use-elapsed-time";
import { useEffectOnce, useIsMounted, useLocalStorage } from "usehooks-ts";

const Stopwatch = ({
  seed,
  gameState,
  playerPath,
  track,
  onComplete,
}: {
  seed: string;
  gameState: "ready" | "pole" | "start" | "playing" | "crashed" | "won";
  playerPath: SVGPathElement | null;
  track: SVGPathElement | null;
  onComplete: (elapsedTime: number, completed: number) => void;
}) => {
  const [pct, setPct] = React.useState(0);
  const [positionProps, setPositionProps] = React.useState<{
    top?: number;
    left?: number;
  }>({ top: undefined, left: 0 });
  const isMounted = useIsMounted();
  const isPlaying = useMemo(() => gameState === "playing", [gameState]);
  const { elapsedTime, reset } = useElapsedTime({ isPlaying });
  const [{ type, value: best }, setPersonalBest] = useLocalStorage(seed, {
    type: "%",
    value: 0,
  });

  React.useEffect(() => {
    if (gameState === "playing") {
      reset();
    }
  }, [reset, gameState]);

  React.useEffect(() => {
    if (gameState !== "won" && gameState !== "crashed") return;

    console.log("ENDING STOPWATCH");
    let roundedPct = 100;
    if (gameState === "crashed") {
      const length = playerPath?.getTotalLength() || 0;
      const totalLength = track?.getTotalLength() || 10_000;
      roundedPct = (length / totalLength) * 100;
    }

    setPct(roundedPct);
    onComplete(elapsedTime, roundedPct);

    const prevType = type;

    if (gameState === "won") {
      if (prevType === "s") {
        setPersonalBest({
          type: "s",
          value: Math.min(elapsedTime, best),
        });
      } else {
        setPersonalBest({
          type: "s",
          value: elapsedTime,
        });
      }
      return;
    }
    if (prevType === "s") return;
    if (gameState === "crashed") {
      setPersonalBest({
        type: "%",
        value: Math.max(Math.round(roundedPct), best),
      });
    }
  }, [playerPath, gameState]);

  useEffect(() => {
    const bbox = track?.getBBox();
    const svg = document.querySelector("svg");
    const box = svg?.getBBox();

    if (bbox && box) {
      // Calculate minimum dimension of path
      const pathMinDim = Math.min(bbox.width - 88, bbox.height - 88);

      // Create square element that fits inside path

      const x = bbox.x + bbox.width / 2 - pathMinDim / 2;
      const y = bbox.y + bbox.height / 2 - pathMinDim / 2;

      const ratio =
        (document?.getElementById("canvas")?.getBoundingClientRect()?.height ||
          10) / box?.height;

      setPositionProps({
        left: (x + bbox.width / 2) * ratio,
        top: (y + pathMinDim / 2) * ratio,
      });
    }
  }, [track]);

  if (!isMounted) return null;
  // if (!positionProps.top || !positionProps.left) return null;

  return (
    <div
      className="global-shadow absolute bottom-0 left-0 z-10 h-[140px] w-[140px] flex flex-col items-center justify-center tabular-nums text-6xl text-white text-center font-Bebas pointer-events-none user-interaction-none select-none"
      // style={{
      //   transform: `translate(-50%, -50%)`,
      //   ...(positionProps.top && positionProps.left ? positionProps : {}),
      // }}
    >
      <div className="select-none pointer-events-none">
        {gameState === "ready" ? (
          <>
            <p>🚥</p>
            <p className="text-2xl">Touch Start</p>
          </>
        ) : null}

        {gameState === "pole" ? (
          <div className="pointer-events-none">
            <p>🏁</p>
            <p className="text-2xl">start tracing</p>
          </div>
        ) : null}

        {isPlaying ? (
          <div className="pointer-events-none">
            <p>
              {elapsedTime.toFixed(2)} <small>s</small>
            </p>
          </div>
        ) : null}

        {/* {gameState === "won" ? (
          <div onClick={tryAgain}>
            <p>
              <small>🏆</small> {elapsedTime.toFixed(2)}
              <small>s</small>
            </p>
            <p className="text-2xl tracking-wider text-center">play again</p>
          </div>
        ) : null}

        {gameState === "crashed" ? (
          <div onClick={tryAgain}>
            <p>{Math.round(pct)}%</p>
            <p className="text-2xl">try again</p>
          </div>
        ) : null} */}
      </div>
    </div>
  );
};

export default Stopwatch;
